import {generateListUidToName} from "@/helper/uidToName";
import {addGetParameters, loadData} from  "@/helper/requests";

export default {
    data() {
        return {
            search: {
                value: '',
                parameter: 'q',
                in_process: false,
            },
            pagination: {
                size_name: 'size',
                page_name: 'page',
                need_reload: false,
                page: 1,
                count: 0,
                size: 10,
                next: false,
                previous: false,
                loading: false,
                current: null,
                filters: {},
                footer_page: {
                    'items-per-page-options':[10,25,50],
                    'show-current-page': true,
                    'show-first-last-page': true
                }
            },
        }
    },
    watch: {
        'pagination.page': function (nVal, oVal) {
            this.setCurrentLoadUrl(
                this.addPageParameter(
                    this.getCurrentLoadUrl()
                )
            )
        },
        'pagination.size': function (nVal, oVal) {
            this.setCurrentLoadUrl(
                this.addSizeParameter(
                    this.getCurrentLoadUrl()
                )
            )
        },
        'pagination.filters': {
            deep: true,
            handler: function (nVal, oVal) {
                this.cleanPaginationPageData();
                this.setCurrentLoadUrl(
                  this.addFiltersParameter(
                    this.getCurrentLoadUrl()
                  )
                )
            }
        },
        'pagination.current': function (nVal, oVal) {
            if(nVal !== oVal && this.pagination.need_reload)
                this.loadData(
                    this.getCurrentLoadUrl()
                )
            if(!this.pagination.need_reload)
                this.pagination.need_reload = true;
        }

    },
    methods: {
        cleanPaginationPageData(){
          /**
           * Сбрасывает данные пагинации для текущей страницы
           */
            this.pagination.page = 1;
            // this.need_reload = false;
        },
        cleanPaginationData(){
          /**
           * Полностью сбрасывает данные пагинации
           */
            this.pagination.size = 10;
            this.pagination.count = 0;
            this.pagination.page = 1;
            // this.need_reload = false;
        },
        mapResults: function (from, to) {
          /**
           * Маппинг результатов API ответа в локальное состояние
           * @param {Object} from - Ответ от сервера
           * @param {string} to - Имя свойства компонента для сохранения результатов
           */
            this[to] = from.results;
            this.mapPagination(from);
        },
        mapPagination: function (from) {
          /**
           * Обновляет данные пагинации из ответа сервера
           * @param {Object} from - Ответ от сервера
           */
            this.pagination.count = from.count;
            this.pagination.next = from.next !== null;
            this.pagination.previous = from.previous !== null;
        },
        setCurrentLoadUrl(url){
          /**
           * Устанавливает текущий URL для загрузки данных
           * @param {string} url - URL для загрузки данных
           */
            this.pagination.current = url;
        },
        getCurrentLoadUrl(){

          /**
           * Получает текущий URL для загрузки данных
           * @returns {string} Текущий URL
           */
            return this.pagination.current;
        },
        loadNames: function (data, uid, fio, finalizer=()=>{}) {
          /**
           * Загружает имена пользователей для массива данных
           * @param {Array} data - Массив объектов данных
           * @param {string} uid - Имя поля с идентификатором пользователя
           * @param {string} fio - Имя поля для сохранения ФИО
           */
            data.forEach(el => {
                this.$set(el, fio, "")
            });
            generateListUidToName(data, uid, fio, finalizer)
        },
        setLoading(){

          /**
           * Устанавливает флаг загрузки
           */
            this.pagination.loading = true;
        },
        setNotLoading(){
          /**
           * Снимает флаг загрузки
           */
            this.pagination.loading = false;
        },
        addSizeParameter(url){
          /**
           * Добавляет параметр размера страницы к URL
           * @param {string} url - Исходный URL
           * @returns {string} URL с параметром размера
           */
            return this.addGetParameter(
                url,
                this.pagination.size_name,
                this.pagination.size,
            )
        },
        addPageParameter(url){
          /**
           * Добавляет параметр страницы к URL
           * @param {string} url - Исходный URL
           * @returns {string} URL с параметром страницы
           */
            return this.addGetParameter(
                url,
                this.pagination.page_name,
                this.pagination.page
            )
        },
        addSearchParameter(url) {
          /**
           * Добавляет параметр поиска к URL
           * @param {string} url - Исходный URL
           * @returns {string} URL с параметром поиска
           */
            return this.addGetParameter(
                url,
                this.search.parameter,
                this.search.value
            )
        },
        addFiltersParameter(url) {
          /**
           * Добавляет параметры фильтров к URL
           * @param {string} url - Исходный URL
           * @returns {string} URL с параметрами фильтров
           */
            return this.addGetParameters(
                url,
                this.pagination.filters
            )
        },
        addGetParameters(url, parameters){
          /**
           * Добавляет несколько GET параметров к URL
           * @param {string} url - Исходный URL
           * @param {Object} parameters - Объект с параметрами
           * @returns {string} URL с добавленными параметрами
           */
            return addGetParameters(url, parameters)
        },
        addGetParameter(url, key, value){
          /**
           * Добавляет GET параметр к URL
           * @param {string} url - Исходный URL
           * @param {string} key - Ключ параметра
           * @param {string} value - Значение параметра
           * @returns {string} URL с добавленным параметром
           */
            return addGetParameters(url, {
                [key]: value,
            })
        },
        searchData: function () {
          /**
           * Выполняет поиск данных
           * Сбрасывает пагинацию и обновляет URL с параметром поиска
           */
            this.cleanPaginationPageData();
            this.setCurrentLoadUrl(
                this.addSearchParameter(
                    this.getCurrentLoadUrl()
                )
            )
        },
        reloadData: function(){
          /**
           * Очищает данные и выполняет загрузку с текущего URL
           */
            this.clearData();
            this.loadData(this.getCurrentLoadUrl());
        },
        clearData(){},
        loadData(url=undefined) {},
    },

}
